<!-- TEMPLATE -->
<template>
  <div class='my-account-class'>
    <dean-two-column-layout title="Mijn account">
      <dean-section-title-item
          :icon='saveIcon'
          slot="title-items"
          :content="true"
          :large="true"
          @click.native="processContact"
      >
        Opslaan
      </dean-section-title-item>
      <div class="column" slot="left">
        <dean-form-row id="givenName" v-model="data.givenName" label="Voornaam"
                       :required-field="true" :warning="$v.data.givenName.$error"
                       @focus="$v.data.givenName.$touch()"></dean-form-row>
        <dean-form-row id="surnamePrefix" v-model="data.surnamePrefix" label="Tussenvoegsels"></dean-form-row>
        <dean-form-row id="surname" v-model="data.surname" label="Achternaam"
                       :required-field="true" :warning="$v.data.surname.$error"
                       @focus="$v.data.surname.$touch()"></dean-form-row>
      </div>
      <div class="column" slot="right">
        <dean-form-row id="phoneNumber" v-model="data.phoneNumber" label="Telefoonnummer"
                       :required-field="true" :warning="$v.data.phoneNumber.$error"
                       @focus="$v.data.phoneNumber.$touch()"></dean-form-row>
        <dean-form-row id="emailAddress" v-model="data.email" label="E-mailadres"
                       :required-field="true" :warning="$v.data.email.$error"
                       @focus="$v.data.email.$touch()"></dean-form-row>
      </div>
    </dean-two-column-layout>
  </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
  // VUE
  import {Component, Vue} from 'vue-property-decorator';
  import axios from 'axios';
  import {validationMixin} from 'vuelidate';
  import {required, email} from 'vuelidate/lib/validators';
  import {Validations} from 'vuelidate-property-decorators';
  import {createNotification} from '@/mixins/validations';

  import {
    deanAlertDialog,
    deanSectionTitle,
    deanSectionTitleItem,
    saveIcon,
    trashIcon,
    warningIcon,
  } from '@deanone/dean-components';
  import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import sideMenuProfileMixin from '@/mixins/sideMenuProfileMixin';
  import {mixins} from 'vue-class-component';

  @Component({
    components: {
      deanAlertDialog,
      DeanTwoColumnLayout,
      deanFormRow,
      deanSectionTitle,
      deanSectionTitleItem,
    },
    mixins: [validationMixin],
  })

  export default class Details extends mixins(sideMenuProfileMixin) {
    public saveIcon: object = saveIcon;
    public trashIcon: object = trashIcon;
    public data: {
      givenName: any,
      surnamePrefix: any,
      surname: any,
      phoneNumber: any,
      email: any,
    } = {
      givenName: null,
      surnamePrefix: null,
      surname: null,
      phoneNumber: null,
      email: null,
    };

    // COMPUTED
    @Validations()
    get validations() {
      return {
        data: {
          givenName: {required},
          surname: {required},
          phoneNumber: {required},
          email: {required, email},
        },
      };
    }

    get accountData(): {
      givenName: any,
      surnamePrefix: any,
      surname: any,
      phoneNumber: any,
      email: any,
    } {
      return this.data;
    }

    public created() {
      const url = '/-/trade/api/user.info';

      this.$store.dispatch('setLoadOverlay', true);

      axios.get(url)
        .then(
          (response) => {
            this.data = response.data;
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
      this.buildSideMenuProfile();
    }

    public processContact() {
      const url = '/-/trade/api/person.update';

      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$store.dispatch('setLoadOverlay', true);

        axios
          .post(url, this.accountData).then(
          (response) => {
            this.$toast(this.$store.state.main.notification.messages.dataSaved);
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
          },
        ).finally(() => {
          this.$store.dispatch('setLoadOverlay', false);
        });
      } else {
        this.$toast(createNotification(this.$v));
      }
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>

</style>
